<configurator-header></configurator-header>
<ion-content scrollY="false">
  <div class="one3d-emi-wrapper">
    <div class="one3d-content-header one3d-custom-border-bottom">
      <h1 class="one3d-content-header-title">{{'EMI.EMI_CALCULATOR' | translate}}</h1>
      <button (click)="closeEMI()">
        <span
          ><img
            src="assets/img/icons/one3d-close-icon.svg"
            alt="close page icon"
        /></span>
      </button>
    </div>

    <div class="one3d-emi-content one3d-scrollable-wrapper-custom">
      <div class="one3d-emi-sections one3d-custom-border-bottom">
        <ion-row>
          <ion-col size="6">
            <h4 class="one3d-emi-variant-title">{{'EMI.VARIANT' | translate}}</h4>
          </ion-col>
          <ion-col size="6">
            <span class="one3d-emi-showroom-text"
              >( {{'EMI.DRIVE_AWAY_PRICE' | translate}} )</span
            >
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="6">
            <span class="one3d-emi-variant-name">{{ variantName }}</span>
          </ion-col>
          <ion-col size="6">
            <span class="one3d-emi-variant-price"
              > {{ globalService.currencyFormatter(exShowroomPrice) }}</span
            >
          </ion-col>
        </ion-row>
      </div>

      <div class="one3d-emi-sections one3d-custom-border-bottom">
        <ion-row>
          <ion-col size="6">
            <span class="one3d-emi-dp-title">{{'EMI.DOWN_PAYMENT' | translate}}</span>
          </ion-col>
          <ion-col size="6">
            <span class="one3d-emi-dp-value"
              >{{ globalService.currencySymbol }}
              <input
                type="text"
                class="one3d-emi-dp-input"
                [ngClass]="{ 'one3d-emi-dp-input-error': showError }"
                name="down-payment"
                id=""
                placeholder="0"
                [(ngModel)]="emiDetails.downPayment"
                (keyup)="calculateEMI()"
                (keypress)="globalService.numberOnlyValidation($event)"
              />
            </span>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="showError" class="one3d-emi-error-row">
          <ion-col size="1">
            <ion-icon name="close-circle" style="color: #aa0c0c"></ion-icon>
          </ion-col>
          <ion-col size="11" class="one3d-emi-col-error">
            <span class="one3d-emi-dp-error">
              {{'EMI.NOTE' | translate}} .
            </span>
          </ion-col>
        </ion-row>
      </div>

      <div class="one3d-emi-sections one3d-custom-border-bottom">
        <ion-row>
          <ion-col size="12">
            <div class="one3d-emi-tenure-section">
              <span class="one3d-emi-annual-title ion-text-start">
                {{'EMI.TENURE' | translate}}
              </span>
              <span class="one3d-emi-variant-price ion-text-end">
                {{ emiDetails.tenureMonths }} <span> ({{'EMI.MONTHS' | translate}}) </span>
              </span>
            </div>
            <div class="one3d-emi-range">
              <ion-range
                class="ion-no-padding"
                min="12"
                max="84"
                pin="true"
                snaps="true"
                step="12"
                mode="ios"
                [(ngModel)]="emiDetails.tenureMonths"
                (ionChange)="calculateEMI()"
              ></ion-range>
            </div>
          </ion-col>
        </ion-row>
      </div>

      <div class="one3d-emi-sections one3d-custom-border-bottom">
        <ion-row>
          <ion-col size="12" class="one3d-emi-sections-annual-col">
            <div class="one3d-emi-annual-header">
              <h3 class="one3d-emi-annual-title">
                {{'EMI.ANNUAL_PERCENTAGE_RATE' | translate}} (APR)
              </h3>
              <button class="one3d-emi-annual-disclaimer-btn">
                <img
                  src="assets/img/icons/one3d-info-icon.svg"
                  alt="info-icon"
                />
              </button>

              <div class="one3d-discalaimer-content">
                <div class="one3d-discalaimer-close ion-text-end">
                  <ion-icon name="close"></ion-icon>
                </div>
                <p class="one3d-discalaimer-content-para">
                  {{'EMI.TERMS_CONDITION' | translate}} .
                </p>
              </div>
            </div>
            <div class="one3-emi-annual-checkbox-section">
              <ion-label class="one3-emi-annual-checkbox-label"
                >{{'EMI.FINANCIAL_SERVICE' | translate}}</ion-label
              >
            </div>
          </ion-col>
        </ion-row>
      </div>

      <div class="one3d-emi-sections" *ngIf="principalLoanAmount > 0">
        <ion-row class="one3d-emi-sections-row-margin">
          <ion-col size="6"
            ><span class="one3d-emi-bottom-title">{{'EMI.FINANCE_NEEDED' | translate}}</span></ion-col
          >
          <ion-col size="6"
            ><span class="one3d-emi-bottom-value"
              >
              {{ globalService.currencyFormatter(principalLoanAmount) }}</span
            ></ion-col
          >
        </ion-row>
        <ion-row class="one3d-emi-sections-row-margin">
          <ion-col size="6"
            ><span class="one3d-emi-bottom-title">{{'EMI.MONTHLY_EMI' | translate}}</span></ion-col
          >
          <ion-col size="6"
            ><span class="one3d-emi-bottom-value"
              > {{ globalService.currencyFormatter(EMI) }}</span
            >
          </ion-col>
        </ion-row>
      </div>
    </div>
  </div>

  <div class="one3d-discalaimer-section">
    <div class="one3d-disclamier-btn-wrapper">
      <button class="one3d-discalaimer-btn">
        <span>
          <ion-icon name="alert-circle-outline"></ion-icon>
        </span>
        <span>{{'EMI.DISCLAIMER' | translate}}</span>
      </button>
    </div>
    <div class="one3d-discalaimer-content">
      <div class="one3d-discalaimer-close ion-text-end">
        <ion-icon name="close"></ion-icon>
      </div>
      <p class="one3d-discalaimer-content-para">
        {{'EMI.DISCLAIMER_NOTE' | translate}}
      </p>
    </div>
  </div>

  <div class="one3d-lhs-config-bottom-wrapper one3d-placeAtBottom">
    <ion-row class="one3d-lhs-config-btn-row">
      <ion-col class="ion-no-padding" size="6">
        <ion-button
          (click)="skipEMI()"
          class="one3d-lhs-config-btn one3d-lhs-config-left-btn"
          expand="full"
          fill="solid"
        >
          {{'EMI.SKIP_EMI' | translate}}
        </ion-button>
      </ion-col>
      <ion-col class="ion-no-padding" size="6">
        <ion-button
          class="one3d-lhs-config-btn one3d-lhs-config-right-btn"
          expand="full"
          [disabled]="showError || emiDetails.downPayment == 0"
          (click)="addToSummary()"
        >
          {{'EMI.ADD_TO_SUMMARY' | translate}}
        </ion-button>
      </ion-col>
    </ion-row>
  </div>
</ion-content>
